<!-- =========================================================================================
    File Name: DuePortfolioSupplierStats.vue
    Description: Due Statistics Portfolio for supplier
    ----------------------------------------------------------------------------------------
========================================================================================== -->

<template>
    <div>
      <vx-card no-shadow v-if="supplierDuePortfolio">
        <div class="vx-row">
          <div class="vx-col w-3/5">
            <h6 class="mt-1 bold">{{mainTitle}}</h6>
          </div>
          <div class="vx-col w-2/5">
            <div class="flex justify-content-end">
              <vx-tooltip
                title="Proyectos vencidos"
                color="danger"
                position="left"
                style="float:right;cursor:pointer;margin-top:-8px"
                text="Ver listado de proyectos vencidos.">
                <vs-button :disabled="supplierDuePortfolio.projects_funded_fall_due_number == 0" color="danger" size="small" icon-pack="feather" icon="icon-eye" v-on:click="showModalProjectsIds = true"></vs-button>
              </vx-tooltip>
              <vx-tooltip
                title="Historial"
                color="success"
                position="left"
                style="float:right;cursor:pointer;margin-top:-8px"
                text="Ver cartera vencida al último año del instalador.">
                <vs-button class="ml-3" color="success" size="small" icon-pack="feather" icon="icon-bar-chart-2" v-on:click="showModalStatistics = true"></vs-button>
              </vx-tooltip>
            </div>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-1/2">
            <label class="mt-1"><strong>Proyectos fondeados: </strong>{{supplierDuePortfolio.projects_funded_number}} ({{explicitMoneyFormat(supplierDuePortfolio.projects_funded_amount)}})</label>
            <br>
            <label><strong>Proyectos vencidos: </strong>{{ supplierDuePortfolio.projects_funded_fall_due_number }} ({{ explicitMoneyFormat(supplierDuePortfolio.projects_funded_fall_due_amount) }}) </label>
          </div>
          <div class="vx-col w-1/2">
            <label><strong>En proyectos: </strong>{{ decimalPercentFormat(supplierDuePortfolio.projects_funded_fall_due_number/supplierDuePortfolio.projects_funded_number) }}</label><br>
            <label class="bold" style="color:#ef5350">En saldo insoluto: {{ decimalPercentFormat(supplierDuePortfolio.projects_funded_fall_due_amount/supplierDuePortfolio.projects_funded_amount) }}</label>
          </div>
        </div>
      </vx-card>
      <!-- LISTADO DE IDS DE PROYECTOS DEL INSTALADOR -->
      <vs-popup :title="'Listado de proyectos del instalador (SID: '+supplierId+')'" :active.sync="showModalProjectsIds">
        <div class="vx-row">
          <!-- <div class="vx-col w-full md:w-1/2">
            <vs-list>
              <vs-list-header title="Proyectos fondeados"></vs-list-header>
              <vs-list-item  v-for="(project, index) in fundedProjectsIds" :title="'PID: '+project" v-bind:key="index">
                <vs-button color="success" size="small" icon-pack="feather" icon="icon-eye" :href="$sanitizeUrl('/cobranza/' + project)" target="blank"></vs-button>
              </vs-list-item>
            </vs-list>
          </div> -->
          <div class="vx-col w-full">
            <vs-list>
              <vs-list-header title="Proyectos vencidos" color="danger"></vs-list-header>
              <vs-list-item  v-for="(project, index) in expiredProjectsIds" :title="'PID: '+project" v-bind:key="index">
                <vs-button color="dark" size="small" icon-pack="feather" icon="icon-eye" :href="$sanitizeUrl('/cobranza/' + project)" target="blank"></vs-button>
              </vs-list-item>
            </vs-list>
          </div>
        </div>
      </vs-popup>
      <!-- HISTORIAL DE LA CARTERA VENCIDA DE UN INSTALADOR -->
      <vs-popup :title="'Cartera vencida del último año del instalador (SID: '+supplierId+')'" :active.sync="showModalStatistics">
        <historical-due-portfolio-supplier-stats v-if="showModalStatistics" :supplierId="supplierId" />
      </vs-popup>
    </div>
</template>

<script>
import formatHelper from '@components/mixins/formatHelper';
import dateHelper from '@components/mixins/dateHelper';
import HistoricalDuePortfolioSupplierStats from "@components/supplier/HistoricalDuePortfolioSupplierStats";

export default{
  name: 'due-portfolio-supplier-stats',
  props: {
    supplierId: {
      type:[Number,String],
      required: true
    },
    realTime: {
      type: Boolean,
      default: true
    }
  },
  components: {
    HistoricalDuePortfolioSupplierStats
  },
  mixins: [formatHelper,dateHelper],
  data () {
    return {
        supplierDuePortfolio:null,
        showModalStatistics:false,
        showModalProjectsIds:false,
        // fundedProjectsIds:[],
        expiredProjectsIds:[]
    }
  },
  computed: {
    mainTitle () {
        let $title = "Cartera vencida del instalador (al día de hoy)";
        if (!this.realTime) {
            $title = "Cartera vencida del instalador al "+this.regularDateFormat(this.supplierDuePortfolio.stats_date);
        }
        return $title;
    }
  },
  async mounted() {
    await this.getSupplierDuePortfolio();
  },
  methods: {
    async getSupplierDuePortfolio(){
      this.showLoading(true);
      let url = '/api/suppliers/calculateDuePortfolioBySupplier/'+this.supplierId;
      if (!this.realTime) {
          url = '/api/suppliers/getLastDuePortfolioBySupplier/'+this.supplierId;
      }
      await axios.get(url).then(response => {
        if (response.data.length > 0) {
          this.supplierDuePortfolio = response.data[0];
          // this.fundedProjectsIds = this.supplierDuePortfolio.projects_funded_ids.split(',');
          this.expiredProjectsIds = this.supplierDuePortfolio.projects_funded_fall_due_ids.split(',');
        }
        this.showLoading(false);
      }).catch(error => {
        this.showLoading(false);
      });
    }
  }
}
</script>
